module.exports = __webpack_public_path__ + "images/file_icons_v2/dat-401134dd2b06393b7a62910b2fbed7be.svg";